import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_URL from '../../ServiceModule/Service';

// Async Thunk for fetching offers
export const fetchOffers = createAsyncThunk('offers/fetchOffers', async () => {
  const response = await axios.get(`${API_URL}/offer/getAllApiOffer`);

  return response.data.data;
});

// Async Thunk for adding an offer
export const addOffer = createAsyncThunk(
  'offers/addOffer',
  async (offerData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/offer/createOffer`, offerData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async Thunk for validating promocode
export const validatePromocode = createAsyncThunk(
  'offers/validatePromocode',
  async (promocodeData, { rejectWithValue }) => {
    try {
      const isGuest = !promocodeData?.cart_id;
      const url = isGuest
        ? `${API_URL}/cart/guest/validatePromocode?promocode=${promocodeData?.promocode}&event_id=${promocodeData?.event_id || ''}`
        : `${API_URL}/cart/validatePromocode?cart_id=${promocodeData?.cart_id}&promocode=${promocodeData?.promocode}&user_id=${promocodeData?.userId || ''}`;
      const response = await axios.get(url, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const removePromocode = createAsyncThunk(
  'offers/removePromocode',
  async ({ cart_id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/cart/removePromocode?cart_id=${cart_id}`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async Thunk for updating an offer
export const updateOffer = createAsyncThunk(
  'offers/updateOffer',
  async (offerData, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_URL}/offer/updateOffer`, offerData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async Thunk for deleting an offer
export const deleteOffer = createAsyncThunk(
  'offers/deleteOffer',
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/offer/deleteOffer?offer_id=${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Offers slice
const offersSlice = createSlice({
  name: 'offers',
  initialState: {
    offers: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    // Handle fetching offers
    builder.addCase(fetchOffers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOffers.fulfilled, (state, action) => {
      state.loading = false;
      state.offers = action.payload;
    });
    builder.addCase(fetchOffers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle adding an offer
    builder.addCase(addOffer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addOffer.fulfilled, (state, action) => {
      state.loading = false;
      state.offers.push(action.payload);
    });
    builder.addCase(addOffer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle updating an offer
    builder.addCase(updateOffer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateOffer.fulfilled, (state, action) => {
      state.loading = false;
      const index = state.offers.findIndex((offer) => offer.id === action.payload.id);
      if (index !== -1) {
        state.offers[index] = action.payload;
      }
    });
    builder.addCase(updateOffer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle deleting an offer
    builder.addCase(deleteOffer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteOffer.fulfilled, (state, action) => {
      state.loading = false;
      state.offers = state.offers.filter((offer) => offer.id !== action.payload);
    });
    builder.addCase(deleteOffer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default offersSlice.reducer;
